// extracted by mini-css-extract-plugin
export default {"root":"styles_root__o-LPl","row":"styles_row__kc0zc","label":"styles_label__UCLcZ","title":"styles_title__jNftd","item":"styles_item__ZbQ+Z","itemFirst":"styles_itemFirst__288vr"};